import * as types from './action-types';
import api from '../utils/api';
import getAuth from '../utils/get-auth';

/**
 * Request the list of notifications for the current user.
 */
export const requestNotificationList = () => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.NOTIFICATIONS_REQUEST_LIST,
      payload: api(`/notifications`, {
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  }
};

export const acceptNotification = (notification) => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.NOTIFICATION_ACCEPT,
      meta: { notification },
      payload: api(`/notifications/${notification.id}/accept`, {
        method: 'POST',
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  }
};


export const declineNotification = (notification) => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.NOTIFICATION_DECLINE,
      meta: { notification },
      payload: api(`/notifications/${notification.id}/decline`, {
        method: 'POST',
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/notifications-actions.js